<script>
	import { onDestroy, onMount } from 'svelte';
	import ErrorNotFoundImg from 'Assets/errors/404.svg';
	import ErrorImg from 'Assets/errors/error.svg';
	import BackofficeError from '$lib/backoffice/components/error/BackofficeError.svelte';
	import { page } from '$app/stores';
	import { backofficeError } from '$lib/backoffice/mobileAppUtils';
	import { isMobileApp } from '$lib/backoffice/backoffice_store';

	/** @type {import('./$types').LayoutServerLoad} */
	export function load({ locals }) {
		console.log('locals', locals);
	}
	let isMobile;
	onMount(() => {
		// for sentry to report
		console.log('error page', $page.error);
		console.error(
			`user encountered a ${$page.status} error : ${JSON.stringify($page.error)}, fileName:${
				$page.error.fileName
			} history:`,
			window.history.valueOf()
		);
		// no backoffice so no triggerMediaQuery will work here
		isMobile = window.innerWidth < 620;
		//for mobile app
		console.log($isMobileApp);
		if ($isMobileApp) {
			console.log('backofficeError called flutter handler');
			backofficeError();
		}
	});
</script>

<BackofficeError image={$page.status == 404 ? ErrorNotFoundImg : ErrorImg} status={$page.status} />
